import { z } from 'zod';
/** 관리자가 자연어로 만들 스킬을 설명하는 입력. */
export const CreateSkillWithAiRequestSchema = z.object({
    prompt: z.string().trim().min(1).max(2000),
});
/**
 * Skill Audit run 의 상태. graphile-worker 가 백그라운드에서 LLM 루프를 돌리고,
 * 클라이언트는 폴링으로 진행 상황 / 결과를 가져온다 (SSE 아님).
 */
export const SkillAuditRunStatusSchema = z.enum([
    'pending',
    'running',
    'completed',
    'failed',
    'cancelled',
]);
/** 진행 events 누적 — DB jsonb 배열로 저장. text_delta 는 저장하지 않음 (잦음). */
export const SkillAuditEventSchema = z.discriminatedUnion('kind', [
    z.object({
        kind: z.literal('progress'),
        at: z.string(),
        message: z.string(),
    }),
    z.object({
        kind: z.literal('iteration'),
        at: z.string(),
        iter: z.number().int().positive(),
        limit: z.number().int().positive(),
    }),
    z.object({
        kind: z.literal('tool_start'),
        at: z.string(),
        toolCallId: z.string(),
        toolName: z.string(),
        argsPreview: z.string(),
    }),
    z.object({
        kind: z.literal('tool_done'),
        at: z.string(),
        toolCallId: z.string(),
        toolName: z.string(),
        status: z.enum(['ok', 'error']),
        summary: z.string(),
    }),
]);
export const SkillAuditRunSchema = z.object({
    id: z.string().uuid(),
    skillId: z.string().uuid(),
    createdBy: z.string().uuid().nullable(),
    status: SkillAuditRunStatusSchema,
    currentSystemPrompt: z.string(),
    proposedSystemPrompt: z.string().nullable(),
    /** LLM 이 보완 제안한 새 pairsWellWith. null = 제안 없음 (= 유지), 배열 = 교체 제안. */
    proposedPairsWellWith: z.array(z.string()).nullable(),
    summary: z.string().nullable(),
    changedAreas: z.array(z.string()),
    error: z.string().nullable(),
    iterationsUsed: z.number().int().min(0),
    events: z.array(SkillAuditEventSchema),
    createdAt: z.string(),
    updatedAt: z.string(),
    completedAt: z.string().nullable(),
});
/** GET .../audit-runs/latest — 아직 한 번도 점검하지 않은 skill 은 null. */
export const SkillAuditRunLatestSchema = z.object({
    run: SkillAuditRunSchema.nullable(),
});
/** POST .../audit-with-ai — 점검 시작. 새 run 의 id 반환. */
export const StartSkillAuditResponseSchema = z.object({
    runId: z.string().uuid(),
});
/** Audit 결과를 적용해 systemPrompt 를 갱신하는 commit body. */
export const AuditSkillCommitRequestSchema = z.object({
    proposedSystemPrompt: z.string().max(10000),
    summary: z.string().min(1).max(2000),
    changedAreas: z.array(z.string().max(80)).max(20).default([]),
    /**
     * cross-domain 동료 skill slug 배열. LLM 점검이 보완 제안한 경우만 전송.
     * undefined = 유지 (DB 갱신 안 함), 빈 배열 = 모두 제거, 채워진 배열 = 교체.
     */
    pairsWellWith: z.array(z.string().min(1).max(40)).max(8).optional(),
});
//# sourceMappingURL=skill-creator.js.map